// extracted by mini-css-extract-plugin
module.exports = {"container":"FeatureList_container__iE9F5","image":"FeatureList_image__5RDcV"};